/**
 * Query key factory for the triggers domain. Every key hangs off `all(orgId)`
 * because every response is authorization-scoped: one org's rows must not be
 * served from a key another org can hit.
 */
export const triggersV2QueryKeys = {
  all: (orgId: string) => ["triggersV2", orgId] as const,
  list: (orgId: string) => [...triggersV2QueryKeys.all(orgId), "list"] as const,
  byName: (orgId: string, name: string) =>
    [...triggersV2QueryKeys.all(orgId), "byName", name] as const,
  byId: (orgId: string, triggerId: string) =>
    [...triggersV2QueryKeys.all(orgId), "byId", triggerId] as const,
  dispatches: (orgId: string, triggerId: string) =>
    [...triggersV2QueryKeys.all(orgId), "dispatches", triggerId] as const,
  // Samples are the same for every org, but the key still hangs off `all` so
  // the convention holds and a sign-out invalidates them with everything else.
  eventSamples: (orgId: string) =>
    [...triggersV2QueryKeys.all(orgId), "eventSamples"] as const,
  datasetDispatches: (orgId: string, datasetId: string) =>
    [
      ...triggersV2QueryKeys.all(orgId),
      "datasetDispatches",
      datasetId,
    ] as const,
};
